import { CommonModule } from "@angular/common";
import { Component, HostListener, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router, RouterModule, NavigationEnd } from "@angular/router";
import { NgbCollapseModule } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { filter } from "rxjs/operators";

import { EventlogsService } from "src/app/services/eventlogs/eventlogs.service";
import { PlantsService } from "src/app/services/plants/plants.service";
import { TrainService } from "src/app/services/trains/trains.service";
import { ConductivityprofilesService } from "src/app/services/conductivityprofiles/conductivityprofiles.service";

import { NavigationComponent } from "src/app/shared/header/navigation.component";
import { NavbarComponent } from "src/app/shared/navbar/navbar.component";
import { SidebarComponent } from "src/app/shared/sidebar/sidebar.component";

import { BreadcrumbModule } from "xng-breadcrumb";
import { NoTrainsFoundComponentComponent } from "src/app/component/no-trains-found-component/no-trains-found-component.component";

@Component({
  selector: "app-main-window",
  standalone: true,
  templateUrl: "./main-window.component.html",
  styleUrls: ["./main-window.component.css"],
  imports: [
    RouterModule,
    SidebarComponent,
    NavigationComponent,
    CommonModule,
    NgbCollapseModule,
    NavbarComponent,
    BreadcrumbModule,
    FormsModule,
    NoTrainsFoundComponentComponent
  ]
})
export class MainWindowComponent implements OnInit {

  plants$: Observable<any[]>;
  plants: any[] = [];
  allTrainList: any[] = [];

  selectedPlantId: number | null = null;
  selectedTrainId: number | null = null;

  menuName: string = "";
  subMenuName: string = "";
  plantDropdownWidth: number = 180;
  trainDropdownWidth: number = 170;
  showPlantDropdown = false;
  selectedPlantName = '';
  showTrainDropdown = false;
  selectedTrainName = '';

  isTrainInPlant: boolean = false;
  showAddButton = false;
  addButtonText = '';
  addButtonRoute: any[] = [];
  plantSearch: string = '';
  trainSearch: string = '';

  showAdminMenuAddButtons = false;
  AdminMenuAddButtonText = '';
  AdminMenuAddButtonRoute = '';

  plantValidation = false;
  showNoTrainPage = false;

  @HostListener('document:click', ['$event'])
  closeDropdown(event: any) {

    const clickedInside =
      event.target.closest('.custom-dropdown');

    if (!clickedInside) {
      this.showPlantDropdown = false;
      this.showTrainDropdown = false;
    }
  }
  constructor(
    private plantService: PlantsService,
    private trainService: TrainService,
    private eventlogService: EventlogsService,
    private conductivityprofilesservice: ConductivityprofilesService,
    private router: Router
  ) { }

  ngOnInit(): void {
      this.plantService.plantValidation$.subscribe(res => {
    this.plantValidation = res;
  });

    // Plant dropdown data
    this.plants$ = this.plantService.plants$;

    this.plants$.subscribe(data => {
      this.plants = data;
    });

    // Selected Plant
    this.plantService.selectedPlant$.subscribe(id => {
      if (id != null) {
        this.selectedPlantId = Number(id);
        if (id != null) {

          const plant = this.plants.find(x => x.Id == id);

          if (plant) {

            this.selectedPlantName = plant.Name;
            this.plantDropdownWidth =
              (plant.Name.length * 8) + 70;
          }

          this.loadPlantData(id);
        }
      }
      else {

        this.selectedPlantId = null;
        this.selectedPlantName = '';
        this.plantDropdownWidth = 180;

        this.allTrainList = [];
        this.isTrainInPlant = false;
      }
    });

    // Selected Train
    this.plantService.selectedTrain$.subscribe(id => {

      if (id) {
        this.selectedTrainId = Number(id);

        const train = this.allTrainList.find(
          x => x.Id == id
        );
        if (train) {

          this.selectedTrainName = train.Name;

          this.trainDropdownWidth =
            (train.Name.length * 8) + 70;
        }
      }
      else {

        this.selectedTrainId = null;
        this.selectedTrainName = '';
        this.trainDropdownWidth = 170;
      }
    });
    // this.plantService.selectedPlant$.subscribe(id => {

    //   this.selectedPlantId = id;

    //   if (id != null) {

    //     const plant = this.plants.find(x => x.Id == id);

    //     if (plant) {
    //       this.selectedPlantName = plant.Name;
    //       this.plantDropdownWidth = (plant.Name.length * 8) + 70;
    //     }

    //     this.loadPlantData(id);

    //   } else {

    //     this.selectedPlantName = '';
    //     this.plantDropdownWidth = 180;
    //   }
    // });

    // Load saved breadcrumb
    this.menuName = localStorage.getItem("menuName") || "";
    this.subMenuName = localStorage.getItem("subMenuName") || "";

    // Route change
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.setBreadcrumbNames(event.urlAfterRedirects);
      });

    // First load
    this.setBreadcrumbNames(this.router.url);
  }

  // -----------------------------------------
  // Show Custom Breadcrumb Area
  // -----------------------------------------
  showCustomBreadcrumb(): boolean {
    const url = this.router.url;

    const paths = [
      "/opdata",
      "/eventlogs",
      "/conductivityprofile",
      "/graph",
      "/plants",
      "/trains",
      "/importmaps",
      "/warrantycondition"
    ];

    return paths.some(path => url.includes(path));
  }

  // -----------------------------------------
  // Plant Change
  // -----------------------------------------
  onPlantChange(plantId: number): void {

    this.selectedPlantId = plantId;
    this.trainSearch = '';
    const selectedPlant = this.plants.find(
      x => x.Id == this.selectedPlantId
    );

    if (selectedPlant) {

      // dynamic width based on selected plant name
      this.plantDropdownWidth =
        (selectedPlant.Name.length * 8) + 70;
      //reset train dropdown width when plant changes
      this.trainDropdownWidth = 170;

    }
    else {

      this.plantDropdownWidth = 180;
      this.trainDropdownWidth = 170;

    }

    this.plantService.setSelectedPlant(plantId);
    this.eventlogService.setPlantId(plantId);
    this.conductivityprofilesservice.setPlantId(plantId);

    this.loadPlantData(plantId);
  }

  // -----------------------------------------
  // Load Train List
  // -----------------------------------------
  loadPlantData(plantId: number): void {
    this.trainService
      .getTrainByPlantId(plantId.toString())
      .subscribe((response: any[]) => {
        this.allTrainList = response;
        this.isTrainInPlant = this.allTrainList.length > 0;
        if (this.isTrainInPlant) {
          this.showNoTrainPage = false;
          // already selected train exists?
          const existingTrain = this.allTrainList.find(
            x => x.Id == this.selectedTrainId
          );

          if (existingTrain) {

            this.selectedTrainName = existingTrain.Name;
            this.trainDropdownWidth =
              (existingTrain.Name.length * 8) + 70;

          } else {

            // plant change → first train auto select
            const firstTrain = this.allTrainList[0];

            this.selectedTrainId = firstTrain.Id;
            this.selectedTrainName = firstTrain.Name;
            this.trainDropdownWidth =
              (firstTrain.Name.length * 8) + 70;

            // IMPORTANT
            this.plantService.setSelectedTrain(firstTrain.Id);
            this.eventlogService.setTrainId(firstTrain.Id);
            this.conductivityprofilesservice.setTrainId(firstTrain.Id);

            // edit page refresh
            if (this.router.url.includes('/component/trains/edit/')) {

              const id = btoa(firstTrain.Id.toString());

              this.router.navigate(
                ['/component/trains/edit/' + id]
              );
            }
          }

        } else {
          this.selectedTrainId = null;
          this.selectedTrainName = '';
          this.allTrainList = [];
          this.isTrainInPlant = false;
          // only train reset
          this.plantService.setSelectedTrain(null);
          this.eventlogService.setTrainId(null);
          this.conductivityprofilesservice.setTrainId(null);
          // keep plant selected
         // this.showNoTrainPage = true;
       
        }
      });
  }

  // -----------------------------------------
  // Train Change
  // -----------------------------------------
  onTrainChange(trainId: number): void {

    this.selectedTrainId = trainId;

    const selectedTrain = this.allTrainList.find(
      x => x.Id == this.selectedTrainId
    );

    if (selectedTrain) {

      // dynamic width based on selected train name
      this.trainDropdownWidth =
        (selectedTrain.Name.length * 8) + 70;

    }
    else {

      this.trainDropdownWidth = 170;

    }

    this.plantService.setSelectedTrain(trainId);
    this.eventlogService.setTrainId(trainId);
    this.conductivityprofilesservice.setTrainId(trainId);

  }
  // -----------------------------------------
  // Menu Click Navigation
  // -----------------------------------------
  navigateMenu(menu: string, subMenu: string, route: string): void {
    this.menuName = menu;
    this.subMenuName = subMenu;

    this.saveBreadcrumb();

    this.router.navigate([route]);
  }

  // -----------------------------------------
  // Dynamic Breadcrumb from URL
  // -----------------------------------------
  setBreadcrumbNames(url: string): void {


    const cleanUrl = url.split('?')[0].toLowerCase();

    // xng-breadcrumb add buttons
    this.showAdminMenuAddButtons = false;

    if (!this.showCustomBreadcrumb()) {

      // USER
      if (cleanUrl === '/user') {
        this.showAdminMenuAddButtons = true;
        this.AdminMenuAddButtonText = 'Add User';
        this.AdminMenuAddButtonRoute = '/component/user/user-add';
      }

      // companies
      else if (cleanUrl === '/companies') {
        this.showAdminMenuAddButtons = true;
        this.AdminMenuAddButtonText = 'Add Company';
        this.AdminMenuAddButtonRoute = '/component/companies/company-add';
      }

      // Models
      else if (cleanUrl === '/models') {
        this.showAdminMenuAddButtons = true;
        this.AdminMenuAddButtonText = 'Add Models';
        this.AdminMenuAddButtonRoute = '/component/models/model-add';
      }

      // Manufacturer
      else if (cleanUrl === '/manufacturers') {
        this.showAdminMenuAddButtons = true;
        this.AdminMenuAddButtonText = 'Add Manufacturer';
        this.AdminMenuAddButtonRoute = '/component/manufacturers/manuf-add';
      }
    }
    // Plant pages -> Project menu nako
    if (
      cleanUrl.includes('/plants') ||
      cleanUrl.includes('/component/plants/edit/')
    ) {

      this.menuName = 'Plant';
      this.subMenuName =
        cleanUrl.includes('/addplant') ? 'Add Plant' :
          cleanUrl.includes('/edit/') ? 'Edit Plant' :
            'Manage';

      this.saveBreadcrumb();

      this.showAddButton = true;
      this.addButtonText = 'Add Plant';
      this.addButtonRoute = ['/component/plants/addplant'];

      return;
    }

    // ---------------------------------
    // Train Master pages only
    // ---------------------------------
    if (
      cleanUrl === '/trains' ||
      cleanUrl === '/component/trains/trains-add' ||
      (
        cleanUrl.startsWith('/component/trains/edit/') &&
        !cleanUrl.includes('/opdata') &&
        !cleanUrl.includes('/rawopdata') &&
        !cleanUrl.includes('/primarygraph') &&
        !cleanUrl.includes('/customgraph') &&
        !cleanUrl.includes('/warrantiesgraph') &&
        !cleanUrl.includes('/warrantycondition')
      )
    ) {

      this.menuName = 'Train Details';

      this.subMenuName =
        cleanUrl.includes('/trains-add')
          ? 'Add Train'
          : cleanUrl.includes('/edit/')
            ? 'Edit Train'
            : 'Manage Train';

      this.saveBreadcrumb();

      this.showAddButton = true;
      this.addButtonText = 'Add Train';
      this.addButtonRoute = ['/component/trains/trains-add'];

      return;
    }

    // ---------------------------------
    // Import Maps
    // ---------------------------------
    if (cleanUrl === '/importmaps') {

      this.menuName = '';
      this.subMenuName = 'Import Maps';

      this.saveBreadcrumb();

      this.showAddButton = false;

      return;
    }



    // ---------------------------------
    // Warranty Condition
    // ---------------------------------
    // if (
    //   cleanUrl === ('/warrantycondition') ||
    //   cleanUrl === ('/component/warrantycondition/add-warranty') ||
    //   cleanUrl === ('/component/warrantycondition/edit/')
    // ) 
    if (
      cleanUrl === '/warrantycondition' ||
      cleanUrl.includes('/component/warrantycondition/add-warranty') ||
      cleanUrl.includes('/component/warrantycondition/edit/') ||
      cleanUrl.includes('/warrantycondition')
    ) {

      // TRAIN EDIT → WARRANTY
      if (
        cleanUrl.startsWith('/component/trains/edit/') &&
        cleanUrl.includes('/warrantycondition')
      ) {

        this.menuName = 'Edit Train';
        this.subMenuName = 'Warranty Condition';

        this.showAddButton = false;
        this.saveBreadcrumb();
        return;
      }

      // NORMAL WARRANTY

      this.menuName = '';

      this.subMenuName =
        cleanUrl.includes('/add-warranty')
          ? 'Add Warranty Condition'
          : cleanUrl.includes('/edit/')
            ? 'Edit Warranty Condition'
            : 'Warranty Condition';

      this.saveBreadcrumb();

      this.showAddButton = true;
      this.addButtonText = 'Add Warranty Condition';
      this.addButtonRoute = [
        '/component/warrantycondition/add-warranty'
      ];

      return;
    }

    const routeMap = [

      // ---------------------------------
      // Operation Data
      // ---------------------------------
      { path: "/opdata/import", menu: "Operation Data", sub: "Import" },
      { path: "/opdata/opdata-add", menu: "Operation Data", sub: "Add" },
      { path: "/opdata/edit/", menu: "Operation Data", sub: "Edit" },
      { path: "/opdata", menu: "Operation Data", sub: "Manage" },

      // Nested Train Child Route
      { path: "/component/trains/edit/", child: "opdata", menu: "Operation Data", sub: "Manage" },
      // { path: "/component/trains/edit/", child: "warrantycondition", menu: "Project", sub: "Manage Warranty Condition" },
      { path: "/component/trains/edit/", child: "warrantiesgraph", menu: "Graphs", sub: "Warranties" },
      { path: "/component/trains/edit/", child: "primarygraph", menu: "Graphs", sub: "Primary" },
      { path: "/component/trains/edit/", child: "customgraph", menu: "Graphs", sub: "Custom" },
      { path: "/trains/", child: "rawopdata", menu: "Operation Data", sub: "Raw" },
      // ---------------------------------
      // Event Logs
      // ---------------------------------
      { path: "/component/eventlogs/edit/", menu: "Event Logs", sub: "Edit" },
      { path: "/eventlogs/add-eventlogs", menu: "Event Logs", sub: "Add" },
      { path: "/eventlogs", menu: "Event Logs", sub: "Manage" },

      // ---------------------------------
      // Conductivity
      // ---------------------------------
      { path: "/conductivityprofile/import-conductivityprofile", menu: "Conductivity Profile", sub: "Import" },
      { path: "/conductivityprofile/add-conductivityprofile", menu: "Conductivity Profile", sub: "Add" },
      { path: "/conductivityprofile", menu: "Conductivity Profile", sub: "Manage" },

      // ---------------------------------
      // Graphs
      // ---------------------------------
      { path: "/primarygraph", menu: "Graphs", sub: "Primary" },
      { path: "/customgraph", menu: "Graphs", sub: "Custom" },
      { path: "/comparisongraph", menu: "Graphs", sub: "Comparison" },
      { path: "/conductivityprofilegraph", menu: "Graphs", sub: "Conductivity" },

      // ---------------------------------
      // Project
      // ---------------------------------
      // { path: "/component/plants/edit/", menu: "Project", sub: "Edit Plant" },
      { path: "/plants", menu: "Project", sub: "Plants" },
      // { path: "/plants/addplant", menu: "Project", sub: "Add Plant" },


      // { path: "/component/trains/edit/", menu: "Project", sub: "Edit Train" },
      // { path: "/trains/trains-add", menu: "Project", sub: "Add Train" },
      // { path: "/trains", menu: "Project", sub: "Train" },

      // { path: "/importmaps", menu: "Project", sub: "Manage Import Maps" },
      // { path: "/warrantycondition", menu: "Project", sub: "Warranty Condition" },
      // { path: "/component/warrantycondition/add-warranty", menu: "Project", sub: "Add Warranty Condition" },
      // { path: "/component/warrantycondition/edit", menu: "Project", sub: "Edit Warranty Condition" },

      { path: "/user", menu: "user", sub: "User" },

    ];


    const matched = routeMap.find(x => {

      const path = x.path.toLowerCase();

      // child route match
      if (x.child) {
        return cleanUrl.startsWith(path) &&
          cleanUrl.includes(x.child.toLowerCase());
      }

      // exact static route
      if (cleanUrl.endsWith(path)) {
        return true;
      }

      // dynamic route like edit/:id
      if (cleanUrl.startsWith(path)) {
        return true;
      }

      return false;
    });

    if (matched) {
      this.menuName = matched.menu;
      this.subMenuName = matched.sub;
      this.saveBreadcrumb();

      this.showAddButton = false;

      // Page wise add button
      switch (matched.path) {

        case '/trains':
          this.showAddButton = true;
          this.addButtonText = 'Add Train';
          this.addButtonRoute = ['/component/trains/trains-add'];
          break;

        case '/plants':
          this.showAddButton = true;
          this.addButtonText = 'Add Plant';
          this.addButtonRoute = ['/component/plants/addplant'];
          break;

        case '/eventlogs':
          this.showAddButton = true;
          this.addButtonText = 'Add Event Logs';
          this.addButtonRoute = ['/eventlogs/add-eventlogs'];
          break;

        case '/warrantycondition':
          this.showAddButton = true;
          this.addButtonText = 'Add Warranty Condition';
          this.addButtonRoute = ['/component/warrantycondition/add-warranty'];
          break;

      }

    }
  }

  // -----------------------------------------
  // Save LocalStorage
  // -----------------------------------------
  saveBreadcrumb(): void {
    localStorage.setItem("menuName", this.menuName);
    localStorage.setItem("subMenuName", this.subMenuName);
  }
  isTrainPage(): boolean {

    const url = this.router.url.toLowerCase();

    return url.includes('/trains') ||
      url.includes('/trains/trains-add') ||
      url.includes('/component/trains/edit/');
  }

  isPlantPage(): boolean {
    const url = this.router.url;

    return url.includes('/plants') ||
      url.includes('/plants/addplant') ||
      url.includes('/component/plants/edit/');
  }

  isWarrantyPage(): boolean {
    const url = this.router.url.toLowerCase();

    return url.includes('/warrantycondition') ||
      url.includes('/component/warrantycondition/add-warranty') ||
      url.includes('/component/warrantycondition/edit/');
  }

  isImportMapPage(): boolean {
    const url = this.router.url.toLowerCase();

    return url.includes('/importmaps');
  }

  isTrainAddPage(): boolean {
  return this.router.url.toLowerCase().includes('/component/trains/trains-add');
}

  getFilteredPlants(plants: any[]) {
    if (!plants) return [];

    return plants.filter(p =>
      p.Name.toLowerCase().includes(this.plantSearch.toLowerCase())
    );
  }

  getFilteredTrains(allTrainList: any[]) {
    if (!allTrainList) return [];
    if (!this.trainSearch) return allTrainList;
    return allTrainList.filter(t =>
      t.Name.toLowerCase().includes(this.trainSearch.toLowerCase())
    );
  }

  onTrainSelect(train: any) {

    this.showTrainDropdown = false;

    if (train) {

      this.selectedTrainId = train.Id;
      this.selectedTrainName = train.Name;

      this.trainDropdownWidth =
        (train.Name.length * 8) + 70;

      this.onTrainChange(train.Id);

      const encodedId = btoa(train.Id.toString());
      const currentUrl = this.router.url.toLowerCase();

      // OPDATA
      if (currentUrl.includes('/opdata')) {

        this.router.navigate(
          ['/trains/edit/' + encodedId + '/opdata']
        );
      }

      // EVENTLOGS
      else if (currentUrl.includes('/eventlogs')) {

        this.router.navigate(
          ['/eventlogs'],
          { queryParams: { trainId: encodedId } }
        );
      }

      // TRAIN EDIT
      else if (currentUrl.includes('/component/trains/edit/')) {

        this.router.navigate(
          ['/component/trains/edit/' + encodedId]
        );
      }
    }
    else {

      this.selectedTrainId = null;
      this.selectedTrainName = '';

      this.onTrainChange(null as any);
    }
  }

  onPlantSelect(plant: any) {

    this.showPlantDropdown = false;

    if (plant) {
      this.selectedPlantId = plant.Id;
      this.selectedPlantName = plant.Name;

      this.plantService.setPlantValidation(false);   
      this.plantDropdownWidth =
        (plant.Name.length * 8) + 70;

      this.onPlantChange(plant.Id);
    }
    else {
      this.selectedPlantId = null;
      this.selectedPlantName = '';
      this.onPlantChange(null as any);
    }
  }

  togglePlantDropdown() {

    this.showPlantDropdown = !this.showPlantDropdown;

    if (!this.showPlantDropdown) {
      this.plantSearch = '';
    }
    // train close
    if (this.showPlantDropdown) {
      this.showTrainDropdown = false;
    }
  }

  toggleTrainDropdown() {
    this.showTrainDropdown = !this.showTrainDropdown;
    if (!this.showTrainDropdown) {
      this.trainSearch = '';
    }
    // plant close
    if (this.showTrainDropdown) {
      this.showPlantDropdown = false;
    }

  }

//   shouldShowNoTrainPage(): boolean {

//   if (!this.selectedPlantId) {
//     return false;
//   }

//   if (this.allTrainList && this.allTrainList.length > 0) {
//     return false;
//   }

//   const url = this.router.url.toLowerCase();

//   // Add Train page
//   if (url.includes('/component/trains/trains-add')) {
//     return false;
//   }

//   // Plant pages
//   if (
//     url.includes('/plants') ||
//     url.includes('/component/plants/edit/')
//   ) {
//     return false;
//   }

//   // Train Manage page
//   if (url === '/trains') {
//     return false;
//   }

//   return this.showCustomBreadcrumb();
// }

shouldShowNoTrainPage(): boolean {
  

    if (!this.selectedPlantId) {
        return false;
    }

    if (this.allTrainList.length > 0) {
        return false;
    }

    const url = this.router.url.toLowerCase();

    // return (
    //     url.includes('/opdata') ||
    //     url.includes('/eventlogs') ||
    //     url.includes('/conductivityprofile') ||
    //     url.includes('/graph') ||
    //     url.includes('/warrantycondition')
    // );
     const validPage =
      url.includes('/opdata') ||
      url.includes('/eventlogs') ||
      url.includes('/conductivityprofile') ||
      url.includes('/graph') ||
      url.includes('/warrantycondition');

  return validPage &&
         this.selectedPlantId != null &&
         this.allTrainList.length === 0 &&
         !this.plantValidation;
}
}
